import Vue from 'vue'
import VueRouter from 'vue-router'
import SignalViewer from '../views/SignalViewer.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'SignalViewer',
    component: SignalViewer
  }
]

const router = new VueRouter({
  routes
})

export default router
